import * as actions from '../../redux/actions';
import * as homeActions from '../../../home/redux/apiCall';

import React, { useEffect, useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
import Carousel from 'react-multi-carousel';
import CommonService from '../../../../services/commonService';
import ThemeFourTitle from './ThemeFourTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const responsive = {
	superLargeDesktop: {
		// the naming can be any, depends on you.
		breakpoint: { max: 4000, min: 3000 },
		items: 2,
	},
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 2,
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 2,
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1,
	},
};

const ThemeFourOfficeSection = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;
	const [offices, setOffices] = useState([]);

	useEffect(() => {
		props.actions.apiCall({
			type: 'home',
			url: ApiUrls.officeDetails(),
			callback: res => onResponse(res),
		});
	}, []);

	const onResponse = res => {
		// console.log('onResponse', res);
		if (res && res.data && res.data.offices && res.data.offices.length > 0) {
			setOffices(res.data.offices);
		}
	};

	return (
		<div className="themes-theme-four-office-section new-container">
			<style>
				.themes-theme-four-office-section .react-multi-carousel-dot--active button {'{'}
				background:{props.activeDotColor};
				{'}'}
			</style>
			{props.office && (
				<Carousel
					responsive={responsive}
					swipeable={false}
					draggable={false}
					showDots={true}
					// infinite={true}
					autoPlay={false}
					autoPlaySpeed={3000}
					customTransition="all .5"
					transitionDuration={3000}
					arrows={false}
					removeArrowOnDeviceType={['tablet', 'mobile']}
				// renderButtonGroupOutside={true}
				>
					{offices &&
						(offices.length || []) &&
						offices.map((val, i) => {
							return <OfficeItem key={i} item={val} operator={operator} offices={offices} />;
						})}
				</Carousel>
			)}

			{props.contactOffice && <ContactOfficeInfo offices={offices} operator={operator} />}
		</div>
	);
};

const ContactOfficeInfo = ({ operator, offices }) => {
	return (
		<div>
			<ThemeFourTitle title="Conoce nuestros terminales de salida" />
			<div className="contact-office-info">
				{offices &&
					offices.length > 0 &&
					offices.map((val, i) => {
						return <ContactItem key={i} item={val} operator={operator} offices={offices} />;
					})}
			</div>
		</div>
	);
};



const ContactItem = ({ key, item, operator, offices }) => {
	return (
		<div className="item" key={key}>
			<div
				className="details"
				style={{
					background: item.bg_color,
				}}
			>
				<div className="info">
					<div className="location">
						<img src={getIcons('pin')} alt="" className="icon" />
						{item.location && item.location.includes(':') ? (
							<span>
								<span className="less-bold-text">{item.location.split(':')[0]}:</span>
							</span>
						) : null}
					</div>
					<div className="contact">
						<span>{item.timings}</span>
					</div>
				</div>
			</div>
		</div>
	);
};



const Iframe = props => {
	return <div dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : '' }} />;
};
const OfficeItem = ({ key, item, operator, offices }) => {
	return (
		<div className="office" key={key}>
			<div
				className="heading less-bold-text"
				style={{
					color:
						operator &&
						operator.color_codes &&
						operator.color_codes &&
						operator.color_codes.secondary_text_color,
					background: item.head_c,
				}}
			>
				{item.city}
			</div>

			<div
				className="details"
				style={{
					background: item.bg_color,
				}}
			>

				{operator && operator.operator_name === "losnavegadores" ?
					(<div className="info py-4 navinfo">

						{operator && operator.operator_name === 'chilebus' ?
							(<div className="location my-0">
								<img src={getIcons('pin')} alt="" className="icon" />
								{/* {item.location && item.location.includes(':') ? (
              <span>
                <span className="less-bold-text">{item.location.split(':')[0]}:</span>
                <span>{item.location.split(':')[1]}</span>
              </span>

            ) : null} */}

								{item.location ? (
									<span>
										{/* <span className="less-bold-text">{item.location.split(':')[0]}:</span> */}
										<span>{item.location}</span>
									</span>
								) : null}
							</div>)
							:
							(<div className="location">
								<img src={getIcons('pin')} alt="" className="icon" />
								{/* {item.location && item.location.includes(':') ? (
              <span>
                <span className="less-bold-text">{item.location.split(':')[0]}:</span>
                <span>{item.location.split(':')[1]}</span>
              </span>

            ) : null} */}

								{item.location ? (
									<span>
										{/* <span className="less-bold-text">{item.location.split(':')[0]}:</span> */}
										<span>{item.location}</span>
									</span>
								) : null}
							</div>
							)}


						{/* <div className="contact">
            <img src={getIcons('contactHeadphone')} alt="" className="icon" />
            <span>{item.contact}</span>
          </div> */}
						{operator.operator_name !== 'santajuana' ? (
							<div className="contact">
								<img src={getIcons('contactHeadphone')} alt="" className="icon" />
								<span>{item.contact}</span>
							</div>
						) : null}

					</div>) : (<div className="info py-4">

						{operator && operator.operator_name === 'chilebus' ?
							(<div className="location my-0">
								<img src={getIcons('pin')} alt="" className="icon" />
								{/* {item.location && item.location.includes(':') ? (
									<span>
											<span className="less-bold-text">{item.location.split(':')[0]}:</span>
											<span>{item.location.split(':')[1]}</span>
									</span>

							) : null} */}

								{item.location ? (
									<span>
										{/* <span className="less-bold-text">{item.location.split(':')[0]}:</span> */}
										<span>{item.location}</span>
									</span>
								) : null}
							</div>)
							:
							(<div className="location">
								<img src={getIcons('pin')} alt="" className="icon" />
								{/* {item.location && item.location.includes(':') ? (
									<span>
											<span className="less-bold-text">{item.location.split(':')[0]}:</span>
											<span>{item.location.split(':')[1]}</span>
									</span>

							) : null} */}

								{item.location ? (
									<span>
										{/* <span className="less-bold-text">{item.location.split(':')[0]}:</span> */}
										<span>{item.location}</span>
									</span>
								) : null}
							</div>
							)}


						{/* <div className="contact">
							<img src={getIcons('contactHeadphone')} alt="" className="icon" />
							<span>{item.contact}</span>
					</div> */}
						{operator.operator_name !== 'santajuana' ? (
							<div className="contact">
								<img src={getIcons('contactHeadphone')} alt="" className="icon" />
								<span>{item.contact}</span>
							</div>
						) : null}

					</div>)
				}
				<div
					style={{
						// height: 200,
						width: '100%',
						marginBottom: 30,
						// borderRadius: 10,
						padding: 15,
					}}
				>
					<Iframe
						iframe={`<iframe src=${item.src} width="100%" height="200" style="border:0;  allowfullscreen="" loading="lazy"></iframe>`}
					/>
				</div>
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFourOfficeSection);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/common/ThemeFourOfficeSection.js